<template>
  <div class="box pb-5">
    <h3 class="text-white p-3">金额统计数据132456</h3>
    <div id="line_chart"></div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  // 引入 ECharts 主模块
  const echarts = require('echarts/lib/echarts');
  // 引入饼状图
  require('echarts/lib/chart/line');
  // 引入提示框和标题组件
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/legendScroll');

  export default {
    name: 'MoneyStatistical',
    computed: {
      ...mapState(['StoreChartLists']),
      moneyList() {
        let title = [];
        let item = this.StoreChartLists.money;
        for (let i in item) {
          title.push({
            title: i,
            pay: item[i].payOrderMoney / 100,
            send: item[i].sendOrderMoney / 100,
            transaction: item[i].transactionOrderMoney / 100,
            type: 'line'
          });
        }
        return title;
      },
      dataArr() {
        return [
          {name:'支付订单金额',type:'line',stack: 'total1',data:this.moneyList.map(v => v.pay)},
          {name:'成交订单金额',type:'line',stack: 'total2',data:this.moneyList.map(v => v.transaction)},
          {name:'发布订单金额',type:'line',stack: 'total3',data:this.moneyList.map(v => v.send)},
        ]
      }
    },
    watch: {
      'moneyList': 'initEchart'
    },
    methods: {
      initEchart() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init($('#line_chart').get(0));

        let option = {
          legend: {
            textStyle:{
                fontSiz:18,
              color:'white'
            },
            data:this.dataArr.map(v => v.name)
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: this.moneyList.map(v => v.title),
            axisLabel: {
              rotate: 45,
              color:'#919191',
            },
            axisLine:{
              lineStyle:{
                color:'white'
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              color:'#919191'
            },
            axisLine:{
              lineStyle:{
                color:'white'
              }
            }
          },
          series: this.dataArr
        };
        // 绘制图表
        myChart.setOption(option);
      }
    }
  }
</script>
<style lang="scss" scoped>
  .box {
    width: 100%;
    background-color: #20283e;
  }

  #line_chart {
    width: 900px;
    height: 500px;
    margin: 0 auto;
  }
</style>
